

<div data-spy="scroll" data-target=".fixed-top">
  <div>
      <!-- Navigation -->
    <app-public-navbar></app-public-navbar>
    <!-- end of navigation -->
  </div>

   
</div>

<section class="privacy-hero">
  <div class="privacy-container">
    <h1>Terms & <span style="color: rgba(86, 173, 255, 1);">Conditions</span></h1>
    <p class="subtext">
      Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generator.
    </p>

    <div class="privacy-layout">
      <!-- Left Side Menu -->
      <aside class="privacy-menu">
        <ul>
          <li><a href="#policy1">Policy 01</a></li>
          <li><a href="#policy2">Policy 02</a></li>
          <li><a href="#policy3">Policy 03</a></li>
          <li><a href="#policy4">Policy 04</a></li>
          <li><a href="#policy5">Policy 05</a></li>
        </ul>
      </aside>

      <!-- Main Content -->
      <div class="privacy-content">
        <section id="policy1">
          <h2>Title of the policy</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed luctus
            lacus eget sapien consequat, id condimentum lorem faucibus. Donec at
            consectetur tortor, id facilisis justo.
          </p>
        </section>

        <section id="policy2">
          <h2>Title of the policy</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
            bibendum consectetur tortor at fermentum. Ut vitae augue nec velit
            porttitor tempor.
          </p>
        </section>

        <section id="policy3">
          <h2>Title of the policy</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
            suscipit suscipit metus, at rhoncus nibh posuere ut. Pellentesque
            habitant morbi tristique senectus et netus.
          </p>
        </section>

        <section id="policy4">
          <h2>Title of the policy</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
            venenatis vehicula risus, in finibus sapien bibendum sit amet.
          </p>
        </section>

        <section id="policy5">
          <h2>Title of the policy</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sed
            orci non felis mollis luctus a in dui. Duis feugiat gravida neque.
          </p>
        </section>
      </div>
    </div>
  </div>
</section>

   <div class="footer">
          <div class="container">
              <div class="row">
                  <div class="col-lg-12">
                      <div class="footer-col first">
                          <h6>About Connekkt Xchange</h6>
                          <p class="p-small">Connekkt Xchange is a next‑generation B2B content marketplace that enables publishers, studios, platforms, and distributors to seamlessly discover, license, distribute, and monetize content across global markets.
                          </p>
                      </div> <!-- end of footer-col -->
                      <div class="footer-col second">
                          <h6>Useful Links</h6>
                          <ul class="list-unstyled li-space-lg p-small">
                              <li><a href="/terms&conditions">Terms & Conditions</a><br/> <a href="/privacy-policy">Privacy
                                      Policy</a><br> <a routerLink="/faqs">FAQs</a><br><a routerLink="/contact-us">Contact Us</a> </li>
                              <!-- <li>Useful: <a href="#">Colorpicker</a>, <a href="#">Icon Library</a>, <a
                                      href="#">Illustrations</a></li>
                              <li>Menu: <a class="page-scroll" href="#header">Home</a>, <a class="page-scroll"
                                      href="#intro">Intro</a>, <a class="page-scroll" href="#features">Features</a>, <a
                                      class="page-scroll" href="#details">Details</a></li> -->
                          </ul>
                      </div> <!-- end of footer-col -->
                      <div class="footer-col third">
                          <span class="fa-stack">
                              <a href="#your-link">
                                 <img class="footer-img" src="assets/newImages/twitter.png" alt="">

                                  <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fab fa-facebook-f fa-stack-1x"></i> -->
                              </a>
                          </span>
                          <span class="fa-stack">
                              <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/facebook.png" alt="">

                                  <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fab fa-twitter fa-stack-1x"></i> -->
                              </a>
                          </span>
                          <span class="fa-stack">
                              <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/instagram.png" alt="">

                                  <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fab fa-pinterest-p fa-stack-1x"></i> -->
                              </a>
                          </span>
                          <span class="fa-stack">
                              <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/pinterest.png" alt="">

                                  <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                  <i class="fab fa-instagram fa-stack-1x"></i> -->
                              </a>
                          </span>
                          <p class="p-small">We would love to hear from you <a
                                  href="mailto:support@connekktxchange.com"><strong>support@connekktxchange.com</strong></a>
                                  <!-- <br/><a
                                      href="tel:+4407466 31893"><strong>+44 07466 331893</strong></a></p> -->
  
                      </div> <!-- end of footer-col -->
                  </div> <!-- end of col -->
              </div> <!-- end of row -->
  
               <!-- Copyright -->
      <div class="copyright">
          <div class="container">
              <div class="row">
                  <div class="col-lg-12">
                      <p class="p-small">Copyright © <a href="#your-link">Connekkt Xchange</a></p>
                  </div> <!-- end of col -->
              </div> <!-- enf of row -->
          </div> <!-- end of container -->
      </div> <!-- end of copyright -->
      
          </div> <!-- end of container -->
      </div> 
